module.exports = __webpack_public_path__ + "static/jobrepublic-logo@3x-310c30f65f970e48103f86213905fe70.png";